// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__go7wF","messages":"Chat_messages__1_3LY","dateDivider":"Chat_dateDivider__2GXT-"};